<template>
    <div class="cruise-rederij-usps width100 nofloat nopadding">
        <span v-for="(item, index) in items" :key="'USPSItem' + index">
            <span class="midgroen marginright5">&#10004;</span>
            {{ item }}<br />
        </span>
    </div>
</template>

<script>
export default {
    name: 'USPSItem',
    props: {
        items: Array,
    },
}
</script>

<style scoped></style>
